$shm_hitalama_guide_toggle $mol_check_icon
	section \
	hint \Руководство пользователя
	Icon <= Help_icon $mol_icon_help_circle_outline
